import {
  Button,
  ConfirmationBox,
  IconText,
  Image,
  Input,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Select from "react-select";
import useAddSplashScreen from "./useAddSplashScreen";
import ColorPickerField from "../../../../utils/components/ColorPickerField";
// import { capitalizeOnSpace } from "../../../../utils/Functions/table";
import Style from "../splashScreen.module.scss";
const AddSplashScreen = ({ isStickyFooter, handleCreateClick, refetch }) => {
  const {
    isEdit,
    formik,
    videoName,
    isLoading,
    // videoPreview,
    arabicVideoName,
    // arabicVideoPreview,
    isLoadingVideo,
    isArabicVideoLoading,
    handleAddSelectedUser,
    handleRemoveSelectedUser,
    handleVideoChange,
    getFieldError,
    closeModal,
    getMinEndDate,
    getMaxDate,
    showAudienceWarning,
    handleConfirmAudienceWarning,
    handleCancelAudienceWarning,
  } = useAddSplashScreen({ handleCreateClick, refetch });
  
  return (
    <div className="row">
      <div className="input-wrap pro-mb-4">
       <Input
              label={"From Date"}
              type="date"
              id="start_date"
              name="start_date"
              className={`pro-input lg ${
                getFieldError("start_date") && " error"
              }`}
              {...formik.getFieldProps("start_date")}
              min={new Date().toISOString().split("T")[0]}
              max={getMaxDate()}
              error={getFieldError("start_date")}
              errorMessage={getFieldError("start_date")}
            />
       
           <Input
              label={"To Date"}
              type="date"
              id="end_date"
              name="end_date"
              className={`pro-input lg ${
                getFieldError("end_date") && " error"
              }`}
              {...formik.getFieldProps("end_date")}
              min={getMinEndDate()}
              disabled={formik?.values?.start_date === ""}
              error={getFieldError("end_date")}
              errorMessage={getFieldError("end_date")}
            />
        <ColorPickerField label="Button Color" name="button_color" formik={formik} />
        <ColorPickerField label="Text Color" name="text_color" formik={formik} />
        <div className="input-wrap pro-mb-4 ">
          <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
            Video
          </label>
          <div className="input-drag">
            <input
              type="file"
              accept=".mp4,.mov , .avi,.mpeg "
              className={`pro-input ${
                formik.errors.media_path && formik.touched.media_path && " error"
              }`}
              id="image"
              onBlur={formik.handleBlur("media_path")}
              onChange={(e) => handleVideoChange(e, "media_path")}
            />
            <span className="input-drag-box">
              <IconText
                title={
                  isLoadingVideo
                    ? "Uploading..."
                    : videoName !== ""
                    ? videoName
                    : `Drop files to attach or browse`
                }
              />
            </span>
            {formik.touched.media_path && formik.errors.media_path && (
              <span className="error-text">{formik.errors.media_path}</span>
            )}
          </div>
          {/* <div className={`col-2 pro-my-2`}>
            <div className={``}>
              <Image
                width={100}
                height={100}
                src={videoPreview}
                alt={`image - 01`}
              />
            </div>
          </div> */}
        </div>
        <div className="input-wrap pro-mb-4 pro-rtl">
          <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
            ( فيديو ) Video
          </label>
          <div className="input-drag">
            <input
              type="file"
              accept=".mp4,.mov,.avi,.mpeg "
              className={`pro-input ${
                formik.errors.alias_media_path &&
                formik.touched.alias_media_path &&
                " error"
              }`}
              id="image"
              onBlur={formik.handleBlur("alias_media_path")}
              onChange={(e) => handleVideoChange(e, "alias_media_path")}
            />
            <span className="input-drag-box">
              <IconText
                title={
                  isArabicVideoLoading
                    ? "...Uploading"
                    : arabicVideoName !== ""
                    ? arabicVideoName
                    : `Drop files to attach or browse`
                }
              />
            </span>
            {formik.touched.alias_media_path && formik.errors.alias_media_path && (
              <span className="error-text">{formik.errors.alias_media_path}</span>
            )}
          </div>
          {/* <div className={`col-2 pro-my-2`}>
            <div className={``}>
              <Image
                width={100}
                height={100}
                src={arabicVideoPreview}
                alt={`image - 01`}
              />
            </div>
          </div> */}
        </div>
        <>
          <div className={Style.add_wrap}>
            <Input
              label={"Add Users"}
              type="text"
              id="add_user"
              name="add_user"
              className={`pro-input lg ${getFieldError("add_user") && "error"}`}
              {...formik.getFieldProps("add_user")}
              onChange={(e) => formik.setFieldValue("add_user", e.target.value??"")}
              error={getFieldError("add_user")}
              errorMessage={getFieldError("add_user")}
            />
            <button
              onClick={handleAddSelectedUser}
              className={`${Style.add_btn}`}
            >
              <span className="material-symbols-outlined x4"> add </span>
            </button>
          </div>
            <div className={`${Style.number_badge_wrap} input-wrap pro-mb-4`}>
              {formik?.values?.user_mobiles?.map((item, index) => (
                <div key={index} className={Style.badge}>
                  {item}
                  <span
                    onClick={() => handleRemoveSelectedUser(index)}
                    className="material-symbols-outlined"
                  >
                    close
                  </span>
                </div>
              ))}
            </div>
          {formik?.errors?.user_mobiles &&
            formik?.values?.user_mobiles?.length <= 0 && (
              <span className="error-text error error-img">
                {getFieldError("user_mobiles")}
              </span>
            )}
        </>
        <div className="pro-check-box pro-flex-column pro-py-2">
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={Boolean(formik.values?.status === 1) ?? false}
              onChange={(e) =>
                formik.setFieldValue(`status`, e?.target?.checked ? 1 : 2)
              }
            />
            <label htmlFor="default" className="pro-check-label">
              Status
            </label>
          </div>
          {getFieldError("status") && (
            <span className="error-text-c1">
              {getFieldError("status")}
            </span>
          )}
        </div>
        <div
          className={`col-12 pro-d-flex pro-justify-end ${
            isStickyFooter && "offcanvas-footer-sticky-btns"
          }`}
        >
          <Button
            className={"pro-btn-link lg pro-px-5"}
            onClick={() => closeModal()}
          >
            Cancel
          </Button>

          <Button
            className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
            type="submit"
            disabled={isLoading || isLoadingVideo || isArabicVideoLoading}
            onClick={formik.handleSubmit}
          >
            {!isEdit
              ? isLoading
                ? "Creating..."
                : "Create"
              : isLoading
              ? "Updating..."
              : "Update"}
          </Button>
        </div>
      </div>

      <ModalLayout
        show={showAudienceWarning}
        handleClose={handleCancelAudienceWarning}
        backdrop="static"
      >
        <div className="pro-m-5">
          <ConfirmationBox
            title={"No splash screen will be active for common users"}
            subTitle={
              "This is the only splash screen shown to users who aren't on a number list. Saving this will leave them with no splash screen until you set up another one for all users."
            }
            cancelText={"Go Back"}
            cancelAction={handleCancelAudienceWarning}
            submitText={"Save Anyway"}
            submitAction={handleConfirmAudienceWarning}
            isRight={true}
          />
        </div>
      </ModalLayout>
    </div>
  );
};

export default AddSplashScreen;
